import styled from '@emotion/styled';

export const FilterBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
